








































import { Component } from 'vue-property-decorator';
import GuardileoAuswahlliste from '@/components/GuardileoAuswahlliste.vue';
import { DrittlandtransferpruefungTabBase } from './TabBase-dltp';

@Component({ components: { GuardileoAuswahlliste } })
export default class extends DrittlandtransferpruefungTabBase {
    async save_changes(event: any) {
        event.preventDefault();
        if (!this.can_save) return;
        this.data = await this.guard_save(() => this.api.Angaben_aendern_neubewertung(this.id, {
            DatumDerPruefung: this.data!.Angaben.DatumDerPruefung,
            WiedervorlageIntervall: this.data!.Angaben.WiedervorlageIntervall,
        }));
        this.on_data();
    }        

    get valid(): boolean {
        return true;
    }
}
